module.exports = __webpack_public_path__ + "static/media/icon_maker_red_3.b42923a9.svg";